import { Link } from 'react-router-dom'
import '../styles/legal.css'

function PrivacyPage() {
  return (
    <div className="legal-page">
      <div className="legal-card">
        <Link to="/login" className="legal-back">&larr; Back to Login</Link>
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last updated: April 9, 2026</p>

        <section>
          <h2>1. Information We Collect</h2>
          <p>When you use CodePulse, we collect the following information:</p>
          <ul>
            <li><strong>Account information:</strong> email address, username, and profile picture</li>
            <li><strong>Submitted code:</strong> Python source code you submit for analysis</li>
            <li><strong>Analysis results:</strong> bug reports, quality scores, and findings generated by our pipeline</li>
            <li><strong>Usage data:</strong> submission timestamps and session information</li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide and maintain the code analysis service</li>
            <li>Store your submission history and analysis reports</li>
            <li>Authenticate your identity and secure your account</li>
            <li>Communicate service-related updates when necessary</li>
          </ul>
        </section>

        <section>
          <h2>3. Data Storage and Security</h2>
          <p>
            Your data is stored securely using Supabase infrastructure with encryption at rest
            and in transit. Authentication tokens are managed through industry-standard JWT
            protocols. We implement security headers and access controls to protect your data.
          </p>
        </section>

        <section>
          <h2>4. Data Sharing</h2>
          <p>
            We do not sell, trade, or share your personal information or submitted code with
            third parties. Your code is processed by our analysis pipeline (AST analysis,
            GPT-4o-mini, and CodeBERT models) solely for the purpose of generating your
            quality report.
          </p>
        </section>

        <section>
          <h2>5. Data Retention</h2>
          <p>
            Your data is retained for as long as your account is active. You may delete
            individual submissions at any time. Deleting your account permanently removes
            all associated data including your profile, submissions, and analysis reports.
          </p>
        </section>

        <section>
          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li><strong>Access:</strong> View all data associated with your account</li>
            <li><strong>Export:</strong> Download your data as a JSON file via Account Settings</li>
            <li><strong>Delete:</strong> Remove individual submissions or your entire account</li>
            <li><strong>Correct:</strong> Update your profile information at any time</li>
          </ul>
        </section>

        <section>
          <h2>7. Cookies and Local Storage</h2>
          <p>
            CodePulse uses browser local storage to maintain your authentication session.
            We do not use third-party tracking cookies. If you select "Remember me" during
            login, your session persists across browser restarts; otherwise it expires when
            you close the tab.
          </p>
        </section>

        <section>
          <h2>8. Third-Party Services</h2>
          <p>CodePulse integrates with the following third-party services:</p>
          <ul>
            <li><strong>Supabase:</strong> Authentication, database, and file storage</li>
            <li><strong>OpenAI:</strong> GPT-4o-mini model for semantic bug prediction</li>
            <li><strong>HuggingFace:</strong> CodeBERT model for validation</li>
          </ul>
          <p>Each service operates under its own privacy policy.</p>
        </section>

        <section>
          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify users of
            significant changes through the Service. Continued use after changes constitutes
            acceptance.
          </p>
        </section>

        <section>
          <h2>10. Contact</h2>
          <p>
            For privacy-related questions or requests, contact us at{' '}
            <a href="mailto:codepulsepp@gmail.com">codepulsepp@gmail.com</a>.
          </p>
        </section>
      </div>
    </div>
  )
}

export default PrivacyPage
